import { render, staticRenderFns } from "./statement-translations-tab.vue?vue&type=template&id=6560220d"
import script from "./statement-translations-tab.vue?vue&type=script&lang=js"
export * from "./statement-translations-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports